import styles from "../../ExpeditionDetails/ExpeditionDetails.module.css";
import star from "/tgstar.svg";
import winnerBanner from "/prize-banner.svg";
import winnerBanner_black from "/public/prize-bannerBlack.svg";
import { Slider } from "../../../../../Components/Slider/Slider";
import { Expedition } from "../../../types";
import { getTicketWord } from "../../../../../Services/utils";
import character_prize from "/giveawayDetailsPrizes/character-prizeNew.png";
import character_prize_black from "/giveawayDetailsPrizes/character-prize_black.png";
import usdt from "/usdtIcon.svg";
import less_dc from "/giveawayDetailsPrizes/less_dc.png";
import less_dc_black from "/giveawayDetailsPrizes/less_dc_black.png";
import many_dc from "/giveawayDetailsPrizes/many_dc.png";
import many_dc_black from "/giveawayDetailsPrizes/many_dc_black.png";
import wheel from "/giveawayDetailsPrizes/prize-tickets-to-spin.png";
import wheel_black from "/giveawayDetailsPrizes/prize-tickets-to-spin_black.png";
import characterLogo from "/character-circle-gold.svg";
import dreamcoinLogo from "/DC_coin.svg";
import usdtLogo from "/usdt.svg";
import { useNotificationStore } from "../../../../../Store/NotificationStore";
import useUserStore from "../../../../../Store/UserStore";
import {
	claimExpeditionReward,
	getExpeditionInfo,
} from "../../../../../Services/Requests";
import { useState, useCallback, useEffect } from "react";
import { motion } from "framer-motion";
import { UserExpeditionReward } from "../../../types";

const getPrizeImage = (
	expedition: Expedition | null,
	prizeIndex: number = 0
): string => {
	if (
		!expedition ||
		!expedition.user_metadata ||
		!expedition.user_metadata.user_rewards ||
		!expedition.user_metadata.user_rewards[prizeIndex]
	) {
		return "";
	}

	const prize = expedition.user_metadata.user_rewards[prizeIndex];

	if (prize.is_claimed === false) {
		switch (prize.currency) {
			case "CHARACTER":
				return character_prize;
			case "USDT":
				return usdtLogo;
			case "DC":
				return prize.amount <= 5000 ? less_dc : many_dc;
			case "TICKET":
				return wheel;
		}
	} else {
		switch (prize.currency) {
			case "CHARACTER":
				return character_prize_black;
			case "USDT":
				return usdtLogo;
			case "DC":
				return prize.amount <= 5000 ? less_dc_black : many_dc_black;
			case "TICKET":
				return wheel_black;
		}
	}
};

const formatNumber = (num: number): string => {
	return num.toLocaleString("en-US");
};

interface FinishedExpeditionInfoProps {
	expedition: Expedition;
	isVisible: boolean;
	setExpedition: React.Dispatch<React.SetStateAction<Expedition | null>>;
}

const FinishedExpeditionInfo: React.FC<FinishedExpeditionInfoProps> = ({
	expedition,
	isVisible,
	setExpedition,
}) => {
	const [currentSlide, setCurrentSlide] = useState<number>(0);

	const setNotification = useNotificationStore(state => state.setNotification);

	const setBalanceDC = useUserStore(state => state.setBalanceDC);
	const setBalanceUSDT = useUserStore(state => state.setBalanceUSDT);
	const setTickets = useUserStore(state => state.setTickets);

	const reRenderExpedition = async () => {
		const data = await getExpeditionInfo(expedition?.id);
		setExpedition(data);
	};

	const isAllRewardsClaimed = expedition?.user_metadata?.user_rewards?.every(
		prize => prize.is_claimed === true
	);

	useEffect(() => {
		if (isAllRewardsClaimed) {
			setTimeout(async () => {
				reRenderExpedition();
			}, 3000);
		}
	}, [isAllRewardsClaimed]);

	const handleClaim = async (currency?: string, prizeIndex?: number) => {
		try {
			let params: { id?: number | undefined; currency?: string } = {};

			if (currency) {
				if (currency === "CHARACTER") {
					params.id = expedition?.user_metadata?.user_rewards?.[prizeIndex!].id;
				} else {
					params.currency = currency;
				}
			}

			const successData = await claimExpeditionReward(
				Number(expedition?.id),
				params
			);
			if (successData.length > 0) {
				successData.forEach(item => {
					if (item.type === "DC") {
						setBalanceDC(item.new_balance);
					} else if (item.type === "USDT") {
						setBalanceUSDT(item.new_balance);
					} else if (item.type === "TICKET") {
						setTickets(item.new_balance);
					}
				});

				await reRenderExpedition();

				if (currency) {
					const currentPrize =
						expedition?.user_metadata?.user_rewards?.[prizeIndex!];

					const normalizedRewardType =
						currentPrize.currency === "CHARACTER"
							? "character"
							: currentPrize.currency === "TICKET"
							? "tickets"
							: currentPrize.currency === "USDT"
							? "USDT"
							: currentPrize.currency === "DC"
							? "DC"
							: "";

					setNotification({
						type: "Success",
						message: "Награда получена",
						rewards: [
							{
								type: normalizedRewardType!,
								amount: currentPrize?.amount || 0,
							},
						],
					});
				} else {
					setNotification({
						type: "Success",
						message: "Все награды получены",
					});
				}
			} else {
				setNotification({
					type: "Error",
					message: "Произошла ошибка при получении награды. Попробуй позже!",
				});
			}
		} catch (e) {
			console.log(e);
			setNotification({
				type: "Error",
				message: "Ошибка при получении награды. Попробуй позже!",
			});
		}
	};

	const renderPrizeItem = useCallback(
		(prize: UserExpeditionReward, index: number) => {
			return (
				<div className={styles.winnerBanner}>
					<img
						className={
							prize.is_claimed === false
								? styles.winnerBannerImg
								: styles.winnerBannerImg_hidden
						}
						src={winnerBanner}
						alt=''
					/>
					<img
						className={
							prize.is_claimed === true
								? styles.winnerBannerImg_black
								: styles.winnerBannerImg_black_hidden
						}
						src={winnerBanner_black}
						alt=''
					/>

					<div className={styles.winnerBannerLeftPart}>
						<div className={styles.winnerBannerPrize}>
							<p className={styles.winnerBannerText}>Твой выигрыш:</p>
							<span className={styles.winnerBannerAmount}>
								{prize.currency === "CHARACTER" ? (
									<>
										{prize.details[0]?.type === "Legendary"
											? "Легендарный"
											: "Эпический"}
									</>
								) : prize.currency === "DC" ? (
									<>{formatNumber(prize.amount)}</>
								) : prize.currency === "USDT" ? (
									<>{formatNumber(prize.amount)}</>
								) : (
									<>
										{formatNumber(prize.amount)} {getTicketWord(prize.amount)}
									</>
								)}
								{prize.currency === "TICKET" ? (
									<></>
								) : (
									<>
										<img
											src={
												prize.currency === "DC"
													? dreamcoinLogo
													: prize.currency === "USDT"
													? usdt
													: prize.currency === "CHARACTER"
													? characterLogo
													: ""
											}
											alt='token'
											className={`${styles.tokenIcon} ${
												prize.is_claimed === true ? styles.tokenIconBlack : ""
											}`}
										/>
									</>
								)}
							</span>
							<button
								onClick={() => handleClaim(prize.currency, index)}
								disabled={prize.is_claimed === true}
								className={
									prize.is_claimed === false
										? styles.claimButton
										: styles.claimedButton
								}
							>
								{prize.is_claimed === false ? "Получить" : "Награда получена"}
							</button>
						</div>
					</div>

					<div
						className={
							prize.currency === "TICKET" || prize.currency === "DC"
								? styles.wheelContainer
								: styles.winnerBannerRightPart
						}
					>
						<img
							src={getPrizeImage(expedition, index)}
							alt='prize'
							className={`${styles.coinsImage} ${
								isVisible ? styles.visible : styles.hidden
							}`}
						/>
					</div>
				</div>
			);
		},
		[expedition, isVisible, handleClaim]
	);

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			transition={{ duration: 0.5 }}
		>
			{expedition?.user_metadata?.user_rewards && (
				<Slider
					listToMap={expedition?.user_metadata?.user_rewards}
					renderItem={(prize, index) => renderPrizeItem(prize, index)}
					currentSlide={currentSlide}
					setCurrentSlide={setCurrentSlide}
					showDots={expedition?.user_metadata?.user_rewards?.length > 1}
				/>
			)}

			<div style={{ marginTop: "10px" }}>
				<button
					className={`${styles.button} ${
						isAllRewardsClaimed ? styles.buttonDisabled : ""
					}`}
					disabled={isAllRewardsClaimed}
					onClick={() => handleClaim()}
				>
					<span>
						{isAllRewardsClaimed
							? "Все награды получены"
							: "Забрать все награды"}
					</span>
					<img src={star} alt='Telegram star' />
				</button>
			</div>
		</motion.div>
	);
};

export { FinishedExpeditionInfo };
